import { KCSDK } from "@/sdk"
import React, { ChangeEvent, useRef } from "react"
import icDownload from "@/assest/ic_file_download.png"
import icUpload from "@/assest/ic_file_upload.png"
import { AppIconButton } from "@/widgets/Common"
import { Flex, Text } from "@chakra-ui/react"

export const FileContent: React.FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  // const taskId = useRef<number | null>(null)

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]

    if (selectedFile) {
      KCSDK.sendLocalFile(selectedFile)
      if (fileInputRef.current) {
        fileInputRef.current.value = ""
      }
    }
  }
  // const stop = () => {
  //   if (taskId.current) {
  //     KCSDK.stopFileTransfer(taskId.current)
  //   }
  // }

  const syncFileToLocal = () => {
    KCSDK.selectRecvFile()
  }

  return (
    <Flex paddingTop="20px" direction={"column"}>
      <Flex justify="space-evenly" id="full-screen-unvideo-element-tag">
        <AppIconButton
          src={icUpload}
          size="86px"
          onClick={() => {
            fileInputRef.current?.click() // 触发文件选择对话框
          }}
        />
        <input
          id="file-upload"
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <AppIconButton src={icDownload} size="86px" onClick={syncFileToLocal} />
      </Flex>
      <Text
        fontSize="12px"
        color="#ffffffe0"
        marginLeft="16px"
        marginRight="16px"
        marginTop="16px"
      >
        文件上传时限速1MB/s，下载时限速125KB/s，大文件建议用网盘同步
      </Text>
    </Flex>
  )
}
